(() => {
const copy = [
 ['Een rustig moment voor een fijne rit.', 'Neem voor het rijden even de tijd voor je paard. Met meerdere massagekoppen en geïntegreerd rood licht combineert Lichtros massage en licht op dezelfde plek. Begin rustig en stem de intensiteit af op wat je paard prettig vindt.', 'Massage van de rug van een paard'],
 ['Ontspannen en samen genieten.', 'De instelbare intensiteit maakt het eenvoudig om je paard op zijn eigen tempo te laten wennen. Begin op de laagste stand en let op zijn reactie. Zo wordt de verzorging een rustig moment samen, met alle aandacht voor je paard.', 'Een rustig verzorgingsmoment met een paard'],
 ['Extra aandacht na een lange rit.', 'Na een lange rit of een drukke dag verdient je paard extra aandacht. Neem tijdens je verzorgingsroutine rustig de tijd voor de grote spiergroepen. Houd de sessie afgestemd op je paard en volg de gebruiksaanwijzing.', 'Verzorging van een paard na het rijden'],
 ['Dagelijkse verzorging in jouw handen.', 'Dankzij het draadloze ontwerp neem je Lichtros eenvoudig mee naar de stal. Zo kun je ook tussen afspraken door tijd maken voor de verzorging van je paard. Het is een aanvulling op je dagelijkse routine en vervangt geen professionele behandeling.', 'Dagelijkse verzorging in de stal']
];
document.querySelectorAll('.lichtros-benefits').forEach((section, index) => {
 if (section.dataset.initialized) return;
 section.dataset.initialized = 'true';
 const dialog = section.querySelector('dialog');
 const heading = dialog.querySelector('h3');
 const paragraph = dialog.querySelector('p');
 const photo = dialog.querySelector('.benefit-photo');
 heading.id = `benefit-heading-${index}`;
 paragraph.id = `benefit-description-${index}`;
 dialog.setAttribute('aria-labelledby', heading.id);
 dialog.setAttribute('aria-describedby', paragraph.id);
 let previousOverflow;
 section.querySelectorAll('[data-benefit]').forEach(button => {
  button.setAttribute('aria-haspopup', 'dialog');
  button.addEventListener('click', () => {
   const n = Number(button.dataset.benefit), content = button.dataset.title ? [button.dataset.title,button.dataset.body,button.dataset.alt] : copy[n];
   heading.textContent = content[0]; paragraph.textContent = content[1];
   photo.src = button.dataset.image; photo.alt = content[2];
   previousOverflow = document.documentElement.style.overflow;
   document.documentElement.style.overflow = 'hidden';
   dialog.showModal(); dialog.scrollTop = 0;
  });
 });
 dialog.querySelector('.benefit-close').addEventListener('click', () => dialog.close());
 dialog.addEventListener('close', () => { document.documentElement.style.overflow = previousOverflow || ''; });
 dialog.addEventListener('click', event => {
  if (event.target !== dialog) return;
  const r = dialog.getBoundingClientRect();
  if(event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
 });
});
})();
